import { render, staticRenderFns } from "./HelpList.vue?vue&type=template&id=5fea4b7e&scoped=true"
import script from "./HelpList.vue?vue&type=script&lang=js"
export * from "./HelpList.vue?vue&type=script&lang=js"
import style0 from "./HelpList.vue?vue&type=style&index=0&id=5fea4b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea4b7e",
  null
  
)

export default component.exports